import { useKeyboard } from '@ionic/vue'

/**
 * @description - watch keyboard open and scroll to y position; to use, add a custom ref attribute to <ion-content> in Vue template and pass to function
 * @param y {number} - scroll to y position
 * @param duration {number} - scroll duration
 */
export function useKeyboardOpenAndScroll(y = 500, duration = 1000) {
  const { isOpen } = useKeyboard()
  const contentEl = ref()

  watch(isOpen, () => {
    contentEl.value?.$el.scrollToPoint(0, y, duration)
  })

  return contentEl
}
